import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditNote = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.34 3c.552 0 1 .448 1 1s-.448 1-1 1H4c-.552 0-1 .448-1 1v14c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-5.34c0-.552.448-1 1-1s1 .448 1 1V20c0 1.657-1.343 3-3 3H4c-1.657 0-3-1.343-3-3V6c0-1.657 1.343-3 3-3zm9.367-1.707l4 4c.39.39.39 1.024 0 1.414l-10 10c-.187.188-.442.293-.707.293H8c-.552 0-1-.448-1-1v-4c0-.265.105-.52.293-.707l10-10c.39-.39 1.024-.39 1.414 0zM18 3.414l-9 9V15h2.586l9-9L18 3.414z"
	})
});
export default SvgEditNote;
